import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70%;
  min-height: 50vh;
`;

export const TitleWrapper = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black7};
`;

export const DescriptionWrapper = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  width: 100%;
  max-width: 432px;
`;
